const accessUserGuide = {

    DOCUMENTS_LIST: {
        path: '/documents-list'
    },

}

export default accessUserGuide;
